import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LenisProvider } from "@/components/LenisProvider";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { Process } from "@/components/Process";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const Home = () => (
  <LenisProvider>
    <div className="App relative">
      <Nav />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <Services />
        <Portfolio />
        <Process />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(9,18,14,0.9)",
            color: "#F8FAFC",
            border: "1px solid rgba(0,208,132,0.25)",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  </LenisProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
